class RatingSelect {
	static select = $context => $context.select('.rating-select');

	constructor($select) {
		this.$select = $select;
		this.init();
		this.bindEvents();
	}
	init() {
		const self = this;
		var value = self.getValue();

		if (!value) {
			return;
		}

		self.$select.find('.rating-select__star').each(function () {
			var $star = $(this);

			if (+$star.data('value') === +value) {
				self.selectStar($star);
			}
		});
	}
	bindEvents() {
		const self = this;
		self.$select.find('.rating-select__stars').on('mouseenter', function () {
			self.$select.addClass('rating-select--hover');
		});

		self.$select.find('.rating-select__stars').on('mouseleave', function () {
			self.$select.removeClass('rating-select--hover');
		});

		self.$select.find('.rating-select__star').on('mouseenter', function () {
			var $star = $(this);
			var $stars = $star.siblings();
			var $hover_stars = $star.prevAll().add($star);
			$stars.removeClass('rating-select__star_hover');
			$hover_stars.addClass('rating-select__star_hover');
			self.setHoverValueText($star.data('text'));
		});

		self.$select.find('.rating-select__star').on('click', function () {
			var $star = $(this);
			self.selectStar($star);
		});
	}
	selectStar($star) {
		const self = this;
		var $stars = $star.siblings();
		var $active_stars = $star.prevAll().add($star);
		$stars.removeClass('rating-select__star_active');
		$active_stars.addClass('rating-select__star_active');
		self.setActiveValueText($star.data('text'));
		self.setValue($star.data('value'));
	}
	getValue() {
		return this.$select.find('.rating-select__input').val();
	}
	setValue(value) {
		return this.$select.find('.rating-select__input').val(value);
	}
	setHoverValueText(text) {
		this.$select.find('.rating-select__hover-value').text(text);
	}
	setActiveValueText(text) {
		this.$select.find('.rating-select__active-value').text(text);
	}

}

export default () => Component(RatingSelect.select, $select => new RatingSelect($select));

